import React from 'react';

export default ({ week, className, blank }) => {
    if (!week) {
        return blank || null;
    }

    const [currentYear, currentWeek] = getCurrentWeek();
    const [givenYear, givenWeek] = week.replace('W', '').split('-').map(n => parseInt(n));

    let ret;

    if (givenYear === currentYear && givenWeek === currentWeek) {
        ret = 'This week';
    } else if (givenYear > currentYear || (givenYear === currentYear && givenWeek >= currentWeek)) {
        ret = futureWeek(currentYear, currentWeek, givenYear, givenWeek);
    } else if (givenYear < currentYear || (givenYear === currentYear && givenWeek <= currentWeek)) {
        ret = pastWeek(currentYear, currentWeek, givenYear, givenWeek);
    } else {
        ret = 'Unknown';
    }

    return <span className={className}>{ret}</span>
}

const getCurrentWeek = () => {
    const d = new Date();
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    // Get first day of year
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    // Calculate full weeks to nearest Thursday
    var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
    // Return array of year and week number
    return [d.getUTCFullYear(), weekNo];
}

const futureWeek = (currentYear, currentWeek, givenYear, givenWeek) => {
    const diff = diffWeeks(currentYear, currentWeek, givenYear, givenWeek);

    if (diff === 1) {
        return 'Next week';
    }

    return `${diff} weeks from now`;
}

const pastWeek = (currentYear, currentWeek, givenYear, givenWeek) => {
    const diff = diffWeeks(givenYear, givenWeek, currentYear, currentWeek);

    if (diff === 1) {
        return 'Last week';
    }

    return `${diff} weeks ago`;
}

const diffWeeks = (firstYear, firstWeek, secondYear, secondWeek) => {
    const diffWeeks = secondWeek - firstWeek;
    const diffYear = secondYear - firstYear;

    return Math.abs(diffWeeks + (diffYear * 52));
}
